module.exports = __webpack_public_path__ + "img/logo_white_hedge.8561fb6b.png";